<template>
  <div class="vue-template">
    <div class="jumbotron bg-gradient">
      <div class="container">
        <span
          class="d-flex align-items-center mb-5
             "
          onclick="
            window.history.go(-1);
            return false;
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="currentColor"
            class="icon-20"
          >
            <path
              d="M 10.8125 9.28125 L 4.09375 16 L 10.8125 22.71875 L 12.21875 21.28125 L 7.9375 17 L 28 17 L 28 15 L 7.9375 15 L 12.21875 10.71875 Z"
              fill="currentColor"
            />
          </svg>
          Zurück</span
        >
        <h1 class="display-4" v-if="user.displayName">
          Welcome, {{ user.displayName }}
        </h1>
      </div>
    </div>

    <div class="container">
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Infos" active>
            <div class="border p-3 mb-2 bg-light text-dark">
              <p class="lead"><strong>E-Mail:</strong> {{ user.email }}</p>
              <p class="lead"><strong>UID:</strong> {{ user.uid }}</p>
              <p class="lead"><strong>Admin:</strong> {{ user.isAdmin }}</p>
            </div></b-tab
          >
          <b-tab title="My Books">
            <div class="box">
              <h2>Your Books</h2>
              <div v-for="book in myBooks" :key="book.id" class="list-item">
                <router-link class="w-100" :to="'/book/' + book.id"
                  ><div>
                    {{ book.title }}
                  </div></router-link
                >
                <div
                  class="btn btn-outline-danger delete"
                  @click="deleteBook(book.id)"
                >
                  x
                </div>
              </div>
            </div></b-tab
          >
          <b-tab title="Inbox"
            ><div class="box">
              <h3>Requests</h3>
              <div
                v-for="message in MessagesFromMe"
                :key="message.id"
                @click="triggerReadStatus(message.id)"
                class="message-item bg-light my-1"
              >
                <span
                  class="badge badge-warning badge-pill"
                  v-if="!message.opened"
                  >!</span
                >
                <span class="badge badge-pill badge-light"
                  >From: {{ message.from }}</span
                >
                <span class="badge badge-pill badge-light"
                  >To: {{ message.to }}</span
                >
                <div>
                  {{ message }}
                </div>
              </div>
            </div>
            <div class="box">
              <h2>Message Inbox</h2>
              <div
                v-for="message in MessagesToMe"
                :key="message.id"
                class="message-item   bg-light my-1"
              >
                <div>
                  <span
                    class="badge badge-warning badge-pill"
                    v-if="!message.opened"
                    >!</span
                  >
                  {{ message.message }}
                </div>
                <span class="badge badge-pill badge-light"
                  >From: {{ message.from }}</span
                >
              </div>
            </div></b-tab
          >
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';

export default {
  data() {
    return {
      users: [],
      user: {
        displayName: null,
        isAdmin: null,
      },
      myBooks: [],
      MessagesFromMe: [],
      MessagesToMe: [],
    };
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        // console.log('Current user =>', user.email);
      } else {
        this.user = null;
        this.$router.push('/login');
      }
    });
  },
  watch: {
    // whenever question changes, this function will run
    fromName: function(userID) {
      return this.$store.users.filter('id' == userID);
    },
    bookName: function(userID) {
      return this.$store.books.filter('id' == userID);
    },
  },
  mounted() {
    this.readBooks();
    this.getUserDate();
    this.getMessagesFromMe();
    this.getMessagesToMe();
  },
  methods: {
    getUserDate() {
      if (firebase.auth().currentUser) {
        let vm = this;
        firebase
          .firestore()
          .collection('users')
          .doc(firebase.auth().currentUser.uid)
          .onSnapshot(function(doc) {
            // console.log(doc.data());
            // console.log(firebase.auth().currentUser.uid);
            vm.user.isAdmin = doc.data().admin;
          });
      }
    },
    getMessagesToMe() {
      if (firebase.auth().currentUser) {
        // console.log(firebase.auth().currentUser.uid);
        firebase
          .firestore()
          .collection('messages')
          .where('to', '==', firebase.auth().currentUser.uid)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.MessagesToMe.push({
                id: doc.id,
                from: doc.data().from,
                to: doc.data().to,
                bookID: doc.data().bookid,
                message: doc.data().message,
                opened: doc.data().opened,
              });
            });
          })
          .catch(error => {
            return error;
            // console.log('Error getting documents: ', error);
          });
      }
    },
    getMessagesFromMe() {
      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('messages')
          .where('from', '==', firebase.auth().currentUser.uid)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.MessagesFromMe.push({
                id: doc.id,
                from: doc.data().from,
                to: doc.data().to,
                bookID: doc.data().bookid,
                message: doc.data().message,
                opened: doc.data().opened,
              });
            });
          })
          .catch(error => {
            return error;
            // console.log('Error getting documents: ', error);
          });
      }
    },
    triggerReadStatus(id) {
      return id;
      // console.log(
      //   this.$store.state.messages.filter(message => message.id == id),
      // );
    },
    readBooks() {
      if (firebase.auth().currentUser) {
        firebase
          .firestore()
          .collection('books')
          .where('owner', '==', firebase.auth().currentUser.uid)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.myBooks.push({
                id: doc.id,
                title: doc.data().title,
                author: doc.data().author,
                description: doc.data().description,
                isBorrowed: doc.data().isBorrowed,
                isBorrowedTo: doc.data().isBorrowedTo,
              });
            });
          })
          .catch(error => {
            return error;
            // console.log('Error getting documents: ', error);
          });
      }
    },
    deleteBook(id) {
      let vm = this;
      firebase
        .firestore()
        .collection('books')
        .doc(id)
        .delete()
        .then(function() {
          // console.log('Document successfully deleted!');
          vm.myBooks = [];
          vm.readBooks();
        })
        .catch(function(error) {
          return error;
          // console.error('Error removing document: ', error);
        });
    },
    logOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          firebase.auth().onAuthStateChanged(() => {
            this.$router.push('/login');
          });
        });
    },
  },
};
</script>
